import { moduleProviderFactory } from 'core/providers';
import { ReceivingManualList, ReceivingEdit, ReceivingDetail, ReceivingAutomatedList } from 'modules/receiving/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.receiving.manual',
				pattern: '/manual',
				isPrivate: true,
				authorization: ['receivingSection.read'],
				children: [
					{
						name: 'master.app.main.receiving.manual.list',
						pattern: '',
						component: ReceivingManualList,
					},
					{
						name: 'master.app.main.receiving.manual.list.add',
						pattern: '/add',
						component: ReceivingEdit,
					},
				],
			},
			{
				name: 'master.app.main.receiving.automated',
				pattern: '/automated',
				isPrivate: true,
				authorization: ['receivingSection.read'],
				children: [
					{
						name: 'master.app.main.receiving.automated.list',
						pattern: '',
						component: ReceivingAutomatedList,
					},
				],
			},
			{
				name: 'master.app.main.receiving',
				pattern: '/containers',
				isPrivate: true,
				authorization: ['receivingSection.read'],
				children: [
					{
						name: 'master.app.main.receiving.edit',
						pattern: '/edit/:id',
						component: ReceivingEdit,
					},
					{
						name: 'master.app.main.receiving.detail',
						pattern: '/detail/:id',
						component: ReceivingDetail,
					},
				],
			},
		],
	});
})();
